<template>
  <v-app>
      <router-view></router-view>
  </v-app>
</template>

<script>
  export default {
    name: 'app',
    metaInfo: {
      title: 'The Operating System For Your Workforce',
      titleTemplate: 'SweldoNow',
      meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'Manage your Philippine workforce through one secure cloud platform. Automated Payroll & BIR Compliance, FaceAI Biometric Attendance, Employee Self-Service, Digital 201 Files & Signatures, Loans, Cash Advances & Reimbursements.' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {},
    computed: {}
  }
</script>
